import styled from '@emotion/styled'

export const FormInlineError = styled.div`
  color: ${props => props.theme.colors.error};
  ${({ theme }) => theme.typography.helpText};
  margin-top: ${({ theme }) => theme.spacing.xs};
  word-break: break-word;
`
